import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchAccountRoles = ({ accountId }) => get(`/accounts/${accountId}/roles`);

export const createAccountRole = ({ accountId, ...params }) => post(`/accounts/${accountId}/roles`, params);

export const updateAccountRole = ({ accountId, accountRoleId, ...params }) =>
  patch(`/accounts/${accountId}/roles/${accountRoleId}`, params);

export const deleteAccountRole = ({ accountId, accountRoleId }) =>
  httpDelete(`/accounts/${accountId}/roles/${accountRoleId}`);
